// De adressen op de bevestigingsmail van een huisbezoek. Nodig omdat Tasks.jsx
// de kopie naar het algemene adres van de organisatie stuurde: bij een
// organisatie waar dat het adres van één medewerker is, kreeg die elke
// bevestiging binnen, ook van afspraken die een collega maakte (updateverzoek
// Ralph van Elburg, Duurzame Vecht, 2026-10-01).
//
// De kopie is voor wie de afspraak maakt: die wil zien wat de bewoner kreeg.
// Het antwoordadres blijft de organisatie: daar hoort een reactie van de
// bewoner binnen te komen, ook als de inplanner er niet is.

import normalizeEmail from '../normalizeEmail'
import { resolveReplyTo } from '../tasks/reminderMailText'

/**
 * @typedef {object} ConfirmationMailAddresses
 * @property {string} cc - Kopie voor wie de afspraak inplant of bevestigt
 * @property {string} replyTo - Waar een antwoord van de bewoner heen gaat
 */

/**
 * @param {object} params
 * @param {string} [params.plannerEmail] - E-mailadres van de ingelogde gebruiker (`Users.Email`)
 * @param {string} [params.companyEmail] - `CompagnyMeta.Email`
 * @returns {ConfirmationMailAddresses}
 */
const confirmationMailAddresses = ({ plannerEmail, companyEmail }) => {
    const replyTo = resolveReplyTo(companyEmail)
    return {
        cc: normalizeEmail(plannerEmail) || replyTo,
        replyTo,
    }
}

export default confirmationMailAddresses
